import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import {
  Info, InfoContainerBase, InfoIconContainerBase,
} from '.';
import { useStyledTheme, WarningIcon } from '../../..';
import { Flex } from '../Flex';

const DefaultContainer = styled(InfoContainerBase)`${({ theme }) => `
  background: ${theme.colours.secondary[7]};
`}`;

const DefaultIconContainer = styled(InfoIconContainerBase)`${({ theme }) => `
  background: ${theme.colours.secondary[1]};
`}`;

const MinorDangerIconContainer = styled(InfoIconContainerBase)`${({ theme }) => `
  background: ${theme.colours.warning[3]};
`}`;

const MinorDangerContainer = styled(InfoContainerBase)`${({ theme }) => `
  background: ${theme.colours.warning[4]};
`}`;

const DangerIconContainer = styled(InfoIconContainerBase)`${({ theme }) => `
  background: ${theme.colours.danger[1]};
`}`;

const DangerContainer = styled(InfoContainerBase)`${({ theme }) => `
  background: ${theme.colours.danger[2]};
`}`;

const IconContainer = styled(Flex)`${({ theme }) => `
  width: ${theme.padding[6]};
`}`;

export function WarningInfo({ children }: PropsWithChildren) {
  return (
    <Info
      Container={DefaultContainer}
      IconContainer={DefaultIconContainer}
      icon={<IconContainer><WarningIcon /></IconContainer>}
    >
      {children}
    </Info>
  );
}

export function WarningInfoDanger({ children }: PropsWithChildren) {
  const theme = useStyledTheme();
  return (
    <Info
      Container={DangerContainer}
      IconContainer={DangerIconContainer}
      icon={<IconContainer><WarningIcon fill={theme.colours.danger[1]} /></IconContainer>}
    >
      {children}
    </Info>
  );
}

export function WarningInfoMinorDanger({ children }: PropsWithChildren) {
  const theme = useStyledTheme();
  return (
    <Info
      Container={MinorDangerContainer}
      IconContainer={MinorDangerIconContainer}
      icon={<IconContainer><WarningIcon fill={theme.colours.warning[3]} /></IconContainer>}
    >
      {children}
    </Info>
  );
}
